import { render, staticRenderFns } from "./OppotunityDetail-AllActivities .vue?vue&type=template&id=d1a83482"
import script from "./OppotunityDetail-AllActivities .vue?vue&type=script&lang=js"
export * from "./OppotunityDetail-AllActivities .vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports